import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { ApolloConsumer } from 'react-apollo'

import { DOWNLOAD_FILE } from '../../queries'

import { Row, Item, Sup, LinkContainer } from './styles'
import { Order } from '../Icons'

class DocumentTableRow extends Component {

  render() {
    let {
      headers,
      item
    } = this.props

    return (
      <Row key={item.id} noPadding>
        <Item>
          <Sup>{headers[0]}</Sup>
          {typeof item.one === 'string' ? item.one : item.one}
        </Item>
        <Item>
          <Sup>{headers[1]}</Sup>
          {typeof item.two === 'string' ? item.two : item.two}
        </Item>
        <Item>
          <Sup>{headers[2]}</Sup>
          {typeof item.three === 'string' ? item.three : item.three}
        </Item>
        <Item>
          <Sup>{headers[3]}</Sup>
          <ApolloConsumer>
            {client => (
              <LinkContainer>
                <a id={`download-${item.one}`} style={{ display: 'none' }} download={item.four}>&nbsp;</a>
                <a
                  onClick={async () => {
                    const { data } = await client.query({
                      query: DOWNLOAD_FILE,
                      variables: { data: { file: item.four, path: 'Opdrachtbonnen' } }
                    });
                    const link = document.getElementById(`download-${item.one}`)
                    link.href = `data:application/octet-stream;base64,${data.downloadFile}`
                    link.click()
                  }}
                >
                  <Order size="" /> Download
                </a>
              </LinkContainer>
            )}
          </ApolloConsumer>
        </Item>
      </Row>
    )
  }
}

export default withRouter(DocumentTableRow)



// WEBPACK FOOTER //
// ./src/components/DocumentTableRow/index.js